export default {
  subject: {
    id: '',
    degreeId: null,
    subjectGroupId: null,
    code: '',
    nameLocal: '',
    nameEng: '',
    description: '',
    creditCalGrade: null,
    creditDesc: '',
  },
  subjects: [],
  processing: false,
  error: null,
  success: null,
}



